import React from "react";
import { getStore } from "./redux/store";

/**
 * Requires a logged-in `me`; otherwise sends the visitor to the root, which redirects to /login.
 *
 * It took an `allowedRoles` argument that nothing ever read — its one caller passed `[1]` and the
 * HOC ignored it, so it advertised role gating it did not do. Per-role access is enforced where it
 * actually happens: `ManagerOnly` in router.js and the `role` allowlist on each `AppNav.MENU` row.
 */
export const Authorization = WrappedComponent => {
  return class WithAuthorization extends React.Component {
    render() {
      const { me } = getStore().getState();
      if (me) {
        return <WrappedComponent {...this.props} currentUser={me} />;
      } else {
        window.location.replace("/");
        return null;
      }
    }
  };
};
